import { use } from 'react';
import { FieldValues } from 'react-hook-form';

import DomipProviderContext from 'features/systems/domip/providers/contexts/domip-provider-context';
import DomipProvider from 'features/systems/domip/providers/domip-provider';
import IPUnitProviderContext from 'features/systems/ip-unit/providers/contexts/ip-unit-provider-context';
import IPUnitProvider from 'features/systems/ip-unit/providers/ip-unit-provider';
import { IS32Provider } from 'features/systems/IS32/context/IS32-provider';
import { SystemType } from '../domain/models/system';

type SystemTypeConfig = {
  Provider?: React.ComponentType<{ children: React.ReactNode }>;
  useConfiguration?: () => {
    updateConfigurationFromForm: (values: FieldValues) => void;
    updateConfigurationIsSuccess: boolean;
    resetForm?: () => void;
  };
};

export const SYSTEM_TYPE_REGISTRY: Record<SystemType, SystemTypeConfig> = {
  [SystemType.Unknown]: {},
  [SystemType.IPUnit]: {
    Provider: IPUnitProvider,
    useConfiguration: () => {
      const {
        updateIPUnitConfigurationIsSuccess: updateConfigurationIsSuccess,
        updateIPUnitConfigurationFromForm: updateConfigurationFromForm,
        resetForm,
      } = use(IPUnitProviderContext);
      return { updateConfigurationFromForm, updateConfigurationIsSuccess, resetForm };
    },
  },
  [SystemType.Domip]: {
    Provider: DomipProvider,
    useConfiguration: () => {
      const {
        updateDomipConfigurationIsSuccess: updateConfigurationIsSuccess,
        updateDomipConfigurationFromForm: updateConfigurationFromForm,
        resetForm,
      } = use(DomipProviderContext);
      return { updateConfigurationFromForm, updateConfigurationIsSuccess, resetForm };
    },
  },
  [SystemType.IS32]: {
    Provider: IS32Provider,
  },
  [SystemType.WanderingPreventionDeso]: {},
};

export const getSystemTypeConfig = (type: SystemType): SystemTypeConfig => {
  return SYSTEM_TYPE_REGISTRY[type] || {};
};
